import { Col, Empty, } from "antd";
import { FC } from "react";
import sendImageFramer from "assets/Images/datanotfoundimage.png";


interface CustomNoDataProps {
  description?: string;
  noDataSrc?:string
}

const CustomNoData: FC<CustomNoDataProps> = (props) => {

  return (
    <>
      <Col xs={24} className="!h-full !flex items-center justify-center !text-xs md:!text-sm">
        <Empty
        style={{display:"!flex",justifyContent:"center"}}
        image={props.noDataSrc|| sendImageFramer}  
        
        description={props.description || "Sonuç Bulunmadı"} />
      </Col>
    </>
  );
};

export default CustomNoData;
